import { render } from "./CreateTranslations.vue?vue&type=template&id=afaabf06&scoped=true"
import script from "./CreateTranslations.vue?vue&type=script&lang=js"
export * from "./CreateTranslations.vue?vue&type=script&lang=js"

import "./CreateTranslations.vue?vue&type=style&index=0&id=afaabf06&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/kft/translate/translate-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afaabf06"]])

export default __exports__